"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.param = param;
exports.getHqIdFromUrl = getHqIdFromUrl;
exports.getRestaurantIdFromUrl = getRestaurantIdFromUrl;
exports.isOnPage = isOnPage;
exports.isDineInUrl = isDineInUrl;
exports.isMarketplacePlatform = isMarketplacePlatform;
exports.getDeviceType = getDeviceType;
exports.isIE = isIE;
exports.getIsChrome = getIsChrome;
exports.getIsEmbedBrowser = getIsEmbedBrowser;
exports.isOnMenu = exports.DEVICE_TYPE = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.to-string.js");

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _lodashEs = require("lodash-es");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//KEEP

/* eslint prefer-template: 0 */

/**
 * Encode data into a URL like jQuery.param()
 * @param obj
 * @param traditional
 * @returns {string}
 */
const DEVICE_TYPE = {
  ANDROID: 'android',
  IOS: 'ios'
}; // note: isOnMenu check will also return true for
// location picker but we do not validate on that page

exports.DEVICE_TYPE = DEVICE_TYPE;
const isOnMenu = isOnPage('locations') && !isOnPage('checkout');
exports.isOnMenu = isOnMenu;

function param(obj, traditional) {
  let params = []; // eslint-disable-line

  params.add = function (key, value) {
    // eslint-disable-line
    if ((0, _lodashEs.isFunction)(value)) value = value(); // eslint-disable-line

    if (value == null) value = ''; // eslint-disable-line

    this.push(escape(key) + '=' + escape(value)); // eslint-disable-line
  };

  serialize(params, obj, traditional); // eslint-disable-line

  return params.join('&').replace(/%20/g, '+'); // eslint-disable-line
}

function serialize(params, obj, traditional, scope) {
  let type;
  const array = (0, _lodashEs.isArray)(obj);
  const hash = (0, _lodashEs.isObject)(obj);
  (0, _lodashEs.each)(obj, function (value, key) {
    type = typeof value;

    if (scope) {
      key = traditional // eslint-disable-line no-param-reassign
      ? scope : scope + '[' + (hash || type === 'object' || type === 'array' ? key : '') + ']'; // eslint-disable-line
    } // handle data in serializeArray() format


    if (!scope && array) {
      params.add(value.name, value.value);
    } else if (type === 'array' || !traditional && type === 'object') {
      // recurse into nested objects
      serialize(params, value, traditional, key);
    } else {
      params.add(key, value);
    }
  });
}

function getHqIdFromUrl() {
  const hqIdRegexPattern = /(?:order|dine-in)\/(\d+)/;
  const result = window.location.href.match(hqIdRegexPattern);
  return (0, _lodashEs.get)(result, '[1]');
}

function getRestaurantIdFromUrl() {
  const isDiscover = process.env.REACT_APP_PACKAGE === 'Marketplace-Web';
  let restaurantIdRegexPattern;

  if (isDiscover) {
    restaurantIdRegexPattern = /restaurant\/(\d+)/;
  } else {
    restaurantIdRegexPattern = /locations\/(\d+)/;
  }

  const result = window.location.href.match(restaurantIdRegexPattern);
  return (0, _lodashEs.get)(result, '[1]');
}

function isOnPage(path) {
  return window.location.pathname.includes(path);
}

function isDineInUrl() {
  return isOnPage('dine-in');
}

function isMarketplacePlatform() {
  const MARKETPLACE_REGEX = /(marketplace)|(eat)/;
  const cookies = new _universalCookie.default();
  return MARKETPLACE_REGEX.test(window.location.hostname) || cookies.get('cn_platform') === 'marketplace';
}

function getDeviceType() {
  let device;

  if (/iPad|iPhone/i.test(navigator.userAgent) || navigator.userAgent.includes('Mac') || navigator.userAgent.match('CriOS') // check for chrome on iOS
  ) {
    device = DEVICE_TYPE.IOS;
  } else if (/Android/i.test(navigator.userAgent)) {
    device = DEVICE_TYPE.ANDROID;
  }

  return device;
}

function isIE() {
  return navigator.appName === 'Microsoft Internet Explorer' || navigator.appName === 'Netscape' && new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})').exec(navigator.userAgent) !== null;
}

function getIsChrome() {
  return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
}

function getIsInstagramEmbed() {
  return navigator.userAgent.indexOf('Instagram') >= 0;
}

function getIsSnapchatEmbed() {
  return navigator.userAgent.indexOf('Snapchat') >= 0;
}

function getIsFacebookEmbed() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
} // Returns true if user in in-app browser for Instagram, Snapchat or Facebook


function getIsEmbedBrowser() {
  return getIsInstagramEmbed() || getIsSnapchatEmbed() || getIsFacebookEmbed();
}